<div id="mobility" class="page-layout-container">
  <div class="row">
    <h1 class="title">Monthly Mobility Allowance Report</h1>
  </div>

  <div class="controls-row">
    <div class="left-controls">
      <mat-form-field appearance="fill" class="month-field">
        <mat-label>Select Month</mat-label>
        <input
          matInput
          [matDatepicker]="selectedMonth"
          required
          (dateChange)="fetchMobilityReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="selectedMonth"
        ></mat-datepicker-toggle>
        <mat-datepicker #selectedMonth></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="standard" class="filter-field">
        <mat-label>Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="search with Employee id, name,.."
          #input
        />
      </mat-form-field>
    </div>

    <div class="right-controls">
      <div class="row-count" *ngIf="hasRows">
        {{ applieMobilityMonths.length }} records
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <ng-container *ngIf="hasRows; else emptyState">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="empName" sticky>
          <th mat-header-cell *matHeaderCellDef>Employee Name</th>
          <td mat-cell *matCellDef="let element">{{ element.empName }}</td>
        </ng-container>

        <ng-container matColumnDef="compHouse" sticky>
          <th mat-header-cell *matHeaderCellDef>Composition House</th>
          <td mat-cell *matCellDef="let element" class="tab-col">
            {{ element.compHouse }}
          </td>
        </ng-container>

        <ng-container matColumnDef="compTravelPass">
          <th mat-header-cell *matHeaderCellDef>Composition Travel</th>
          <td mat-cell *matCellDef="let element">
            {{ element.compTravelPass }}
          </td>
        </ng-container>

        <ng-container matColumnDef="compOthers">
          <th mat-header-cell *matHeaderCellDef>Composition Others</th>
          <td mat-cell *matCellDef="let element">{{ element.compOthers }}</td>
        </ng-container>

        <ng-container matColumnDef="totalAllowanceApplied">
          <th mat-header-cell *matHeaderCellDef>Total Allowance Applied</th>
          <td mat-cell *matCellDef="let element">
            {{ element.totalAllowanceApplied }}
          </td>
        </ng-container>

        <ng-container matColumnDef="comments">
          <th mat-header-cell *matHeaderCellDef>Comments</th>
          <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
        </ng-container>

        <ng-container matColumnDef="appliedBy">
          <th mat-header-cell *matHeaderCellDef>Applied By</th>
          <td mat-cell *matCellDef="let element">{{ element.appliedBy }}</td>
        </ng-container>

        <ng-container matColumnDef="appliedDate">
          <th mat-header-cell *matHeaderCellDef>Applied Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.appliedDate | date: "dd/MMMM/yyyy" }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </ng-container>

    <ng-template #emptyState>
      <div class="empty-state card">
        <h3>No records found</h3>
        <p>
          Select a month to generate the mobility allowance report. If no data
          exists for the selected month, no records will be displayed.
        </p>
      </div>
    </ng-template>
  </div>
</div>
